import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.ListItemFilters, {
        attrs: {
          icon: "ui-icon-doctor",
          title:
            _setup.lpuFiltersState.doctorSpeciality?.name ||
            _setup.t("Специальность врача", _setup.options),
          subtitle: _setup.lpuFiltersState.doctorSpeciality
            ? _setup.t("Специальность врача", _setup.options)
            : "",
        },
        on: { click: _setup.openDialog },
      }),
      _vm._v(" "),
      _c(_setup.DoctorSpecialityModal, {
        attrs: { value: _setup.isDialogOpened, "is-back": "" },
        on: {
          "speciality:selected": _setup.onClickDoctorSpeciality,
          input: _setup.handleCloseDoctorSpecialityModal,
        },
        scopedSlots: _vm._u([
          {
            key: "footer",
            fn: function ({ selectedSpeciality }) {
              return [
                _c(
                  "div",
                  { staticClass: "pa-2 elevation-8" },
                  [
                    _c(
                      VBtn,
                      {
                        attrs: {
                          block: "",
                          depressed: "",
                          color: "primary",
                          disabled: !_setup.hasUnsavedDoctorSpeciality,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.handleDoctorSpecialitySelected(
                              selectedSpeciality
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t("Применить", _setup.options)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }